export const MenuTooltipProperty = {
  IsDropdownViewable: 'isDropdownViewable',
  IsRightSide: 'isRightSide',
};

export const MenuTooltipSlotName = {
  Trigger: 'trigger',
  Dropdown: 'dropdown',
};
